import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, ChevronRight } from 'lucide-react';

const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);

  const breadcrumbMap = {
    'practices': 'Practices',
    'family-matters': 'Family Matters',
    'civil-matters': 'Civil Matters',
    'criminal-matters': 'Criminal Matters',
    'about': 'About Us',
    'firm': 'The Firm',
    'leadership': 'The Leadership',
    'documentations': 'Documentations',
    'contact': 'Contact Us'
  };

  return (
    <nav className="flex items-center space-x-2 text-sm text-gray-600 py-4">
      <Link to="/" className="hover:text-gold transition-colors duration-200">
        <Home className="w-4 h-4" />
      </Link>
      
      {pathnames.length > 0 && <ChevronRight className="w-4 h-4" />}
      
      {pathnames.map((name, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
        const isLast = index === pathnames.length - 1;
        const displayName = breadcrumbMap[name] || name;

        return (
          <React.Fragment key={name}>
            {isLast ? (
              <span className="text-gold font-medium">{displayName}</span>
            ) : (
              <>
                <Link to={routeTo} className="hover:text-gold transition-colors duration-200">
                  {displayName}
                </Link>
                <ChevronRight className="w-4 h-4" />
              </>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;